import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AccessProvider } from './access-context'
import { keeper } from './api'
import { CaptureProvider } from './capture/capture-context'
import { LocaleProvider } from './i18n'
import { router } from './router'
import { isNativeShell } from './shell'
import { start } from './start'
import { reportError, startTelemetry } from './telemetry'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('no #root element')
const element = root

/**
 * A2: the iPad app's shell, set up before the first render. `__NATIVE_SHELL__`
 * is a literal at build time (vite.config.ts): false in every build but the
 * iOS one, so this import and its plugins are not in them at all.
 */
const tokenKeeper = keeper
const install =
  __NATIVE_SHELL__ && tokenKeeper && isNativeShell()
    ? async () => (await import('./native/install')).installNativeShell({ keeper: tokenKeeper })
    : null

// S2: errors are reported from the first line of the app on (telemetry.ts).
startTelemetry()

void start({
  install,
  render: () =>
    createRoot(element, {
      // What no error boundary caught: the whole app is lost to it.
      onUncaughtError: (error) =>
        void reportError(error, { mechanism: 'react.uncaught', handled: false }),
    }).render(
      <StrictMode>
        <LocaleProvider>
          <AccessProvider>
            <CaptureProvider>
              <RouterProvider router={router} />
            </CaptureProvider>
          </AccessProvider>
        </LocaleProvider>
      </StrictMode>,
    ),
})
